import styled from 'styled-components';

export const Container = styled.div``;

/** The design's stats layout — content, then a fixed control rail. */
export const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: var(--s5);
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;
